import React from 'react';
import cx from 'classnames';
import { Success } from './icons/Success.js';
import { Error } from './icons/Error.js';
import { Info } from './icons/Info.js';
import { Refresh } from './icons/Refresh.js';
import { Time } from './icons/Time.js';
import styles from './index.module.scss.js';

const ToastIcon = ({ type, className, style, ...props }) => {
  const getIcon = () => {
    if (type === "success") return /* @__PURE__ */ React.createElement(Success, null);
    if (type === "error") return /* @__PURE__ */ React.createElement(Error, null);
    if (type === "info") return /* @__PURE__ */ React.createElement(Info, null);
    if (type === "waiting") return /* @__PURE__ */ React.createElement(Time, null);
    if (type === "refresh") return /* @__PURE__ */ React.createElement(Refresh, null);
    return /* @__PURE__ */ React.createElement(Info, null);
  };
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles.wrapper, className), style, ...props }, getIcon());
};
ToastIcon.displayName = "ToastIcon";

export { ToastIcon };
//# sourceMappingURL=index.js.map
